import { Button } from "@twinkltech/web-ui";

export const FilterButton = ({
  children,
  isActive = false,
  nextFilterId,
  previousFilterId,
  ...props
}: {
  isActive?: boolean;
  nextFilterId?: string;
  previousFilterId?: string;
} & React.ComponentPropsWithoutRef<typeof Button>) => {
  return (
    <Button
      aria-current={isActive ? "true" : undefined}
      className={[
        // Base styles
        "border-2 font-normal",

        // Default/"Resting" state styles
        "border-neutral-150 bg-white",

        // pseudo-state styles
        "hover:border-blue-100 focus-within:border-blue-100 ",

        // Current filter styles
        "[&[aria-current]]:bg-blue-50 [&[aria-current=true]]:border-blue-200",

        // Disabled state styles
        "disabled:border-neutral-100! disabled:bg-neutral-100 disabled:text-neutral-500",
      ]
        .filter(Boolean)
        .join(" ")}
      role="button"
      variant="outlined"
      onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
        if (nextFilterId && (e.key === "ArrowRight" || e.key === "ArrowDown")) {
          e.preventDefault();
          document.getElementById(nextFilterId)?.focus();
        }
        if (
          previousFilterId &&
          (e.key === "ArrowLeft" || e.key === "ArrowUp")
        ) {
          e.preventDefault();
          document.getElementById(previousFilterId)?.focus();
        }
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
